// TODO: 各所に以下と同じ名前、同じ目的の変数定義が多数あるのでここからimportするようにリファクタリングする

export const SORT_ORDER_UPDATE_DATE_DESC = 'UpdateDateDesc';
export const SORT_ORDER_SESSION_COUNT_DESC = 'SessionCountDesc';
export const SORT_ORDER_LIKE_COUNT_DESC = 'LikeCountDesc';

export type SortOrder =
  | typeof SORT_ORDER_UPDATE_DATE_DESC
  | typeof SORT_ORDER_SESSION_COUNT_DESC
  | typeof SORT_ORDER_LIKE_COUNT_DESC;

export const sortOrders: SortOrder[] = [
  SORT_ORDER_UPDATE_DATE_DESC,
  SORT_ORDER_SESSION_COUNT_DESC,
  SORT_ORDER_LIKE_COUNT_DESC,
];
